import { BaseEditModel } from "model/BaseEditModel";
import Produto from "model/administracao/cadastro/produto/Produto";
import OrdemProducao from "./OrdemProducao";
import Pedido from "./Pedido";

export default class ItemPedido implements BaseEditModel {
    id: number;
    key: string = "";
	sequencial: number;
	qtPedida: number;
	qtFaturada: number;
    qtDisponivelFaturamento?: number;
	precoUnitario: number;
	status: string;
	produto: Produto;
    pedido: Pedido|null;
    ordensProducao: OrdemProducao[];

    constructor(
        id: number = 0,
        sequencial: number = 0,
        qtPedida: number = 0,
        qtFaturada: number = 0,
        precoUnitario: number = 0,
        status: string = "ABERTO",
        produto: Produto = new Produto(),
        pedido: Pedido|null = null,
        ordensProducao: OrdemProducao[] = []
    ) {
        this.id = id;
        this.sequencial = sequencial;
        this.qtPedida = qtPedida;
        this.qtFaturada = qtFaturada;
        this.precoUnitario = precoUnitario;
        this.status = status;
        this.produto = produto;
        this.pedido = pedido;
        this.ordensProducao = ordensProducao;
    }
}